// common/SelectOptions/BooleanOptions.js

export const BooleanOptions = [{label: "Yes", value: true}, {label: "No", value: false}];